export default __webpack_public_path__ + "static/breadcrumbs-overflow-5d38c2b6e5d817f2c5af52a8360dd13b237fd388647f75818c7961eb582f14b4.png";